import React, { useEffect } from "react";
import {
  DeliveryDetails,
  NotInStock,
  OrderPlaced,
  StockConfirmation,
} from "../../components/Order/OrderPlaced";
import { LocalShipping } from "@mui/icons-material";
import deployed_code_account from "../../assets/icons/deployed_code_account.svg";
import deployed_code_history from "../../assets/icons/deployed_code_history.svg";
import inventory_icon from "../../assets/icons/inventory.svg";
import { useDispatch, useSelector } from "react-redux";
import { getOrderTimeline } from "../../redux/Orders/ordersAction";
import moment from "moment";

const OrderTimeline = ({ id }) => {
  const dispatch = useDispatch();
  const { orderTimelineLoading, orderTimelineData } = useSelector(
    (state) => state.orders
  );

  useEffect(() => {
    dispatch(getOrderTimeline({ id }));
  }, [dispatch, id]);

  return (
    <div className="w-full">
      {" "}
      <p className="text-[#4B564D] font-semibold text-sm w-full mb-2 px-4 ">
        Timeline
      </p>
      {orderTimelineLoading ? (
        <div className="w-full flex justify-center items-center text-center h-[200px]">
          <p className="text-[#4B564D] font-semibold text-sm w-full mb-2 px-4 ">
            Loading...
          </p>
        </div>
      ) : (
        <>
          {" "}
          {Object.keys(orderTimelineData)?.length === 0 ||
          orderTimelineData?.length === 0 ? (
            <div className="w-full flex justify-center items-center text-center h-[200px]">
              <p className="text-[#4B564D] font-semibold text-sm w-full mb-2 px-4 ">
                No Timeline Available
              </p>
            </div>
          ) : (
            <>
              {orderTimelineData?.map((timeline) => {
                return (
                  <div key={crypto.randomUUID()} className="w-full">
                    {timeline?.order_status === "PENDING" &&
                    timeline.event_type === "order_created" ? (
                      <>
                        <OrderPlaced
                          name={timeline?.user || "N/A"}
                          time={moment(timeline?.created).format(
                            "MMM DD, YYYY hh:mm A"
                          )}
                          paymentStatus={timeline?.paid || false}
                        />
                      </>
                    ) : timeline?.order_status === "ACCEPTED" &&
                      timeline.event_type === "order_accepted" ? (
                      <>
                        <StockConfirmation
                          name={timeline?.user || "N/A"}
                          time={moment(timeline?.timestamp).format(
                            "MMM DD, YYYY hh:mm A"
                          )}
                          department={timeline?.department || "N/A"}
                        />
                      </>
                    ) : timeline?.order_status === "ACCEPTED" &&
                      timeline.event_type === "delivery_address_updated" ? (
                      <div>
                        <DeliveryDetails
                          name={timeline?.user || "N/A"}
                          time={moment(timeline?.timestamp).format(
                            "MMM DD, YYYY hh:mm A"
                          )}
                          info={
                            timeline?.delivery_info || {
                              lga: "",
                              state: "",
                              address: "",
                              delivery_type: "",
                              delivery_price: "",
                              estimated_date: "",
                            }
                          }
                          department={timeline?.department || "N/A"}
                        />
                      </div>
                    ) 
                    : timeline.event_type === "delivery_address_updated" ? (
                      // Handle delivery_address_updated regardless of order_status
                      <div>
                        <DeliveryDetails
                          name={timeline?.user || "N/A"}
                          time={moment(timeline?.timestamp || timeline?.created).format(
                            "MMM DD, YYYY hh:mm A"
                          )}
                          info={
                            timeline?.delivery_info || {
                              lga: timeline?.delivery_info?.lga || "",
                              state: timeline?.delivery_info?.state || "",
                              address: timeline?.delivery_info?.address || "",
                              delivery_type: timeline?.delivery_info?.delivery_type || "",
                              delivery_price: timeline?.delivery_info?.delivery_price || "",
                              estimated_date: timeline?.delivery_info?.estimated_date || "",
                            }
                          }
                          department={timeline?.department || "Customer Success Team"}
                          orderStatus={timeline?.order_status}
                        />
                      </div>
                     )
                    : timeline?.order_status === "REJECTED" &&
                      timeline.event_type === "order_rejected" ? (
                      <div>
                        <NotInStock
                          name={timeline?.user || "N/A"}
                          time={moment(timeline?.created).format(
                            "MMM DD, YYYY hh:mm A"
                          )}
                          department={timeline?.department || "N/A"}
                          note={
                            timeline?.notes || {
                              created_by: "",
                              id: 0,
                              text: "",
                              title: "",
                            }
                          }
                        />
                      </div>
                    ) : 
                    timeline?.order_status === "ASSIGNED" &&
                  timeline.event_type === "store_manager_assigned" ? (
                    <div className="w-full px-4 py-2 border-t border-t-[#E1E6E1]">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="font-semibold text-[#2E332F] text-sm">{timeline?.user || "N/A"}</span>
                        <span className="bg-[#F6F7F6] border border-[#E1E6E1] text-[#5F6D60] text-xs font-semibold px-1 py-1 rounded">{timeline?.department || "Customer Success Team"}</span>
                        <span className="ml-auto text-[#5F6D60] text-xs">{moment(timeline?.timestamp || timeline?.created).fromNow()}</span>
                      </div>
                      <div className="flex items-center gap-2 mt-2">
                         <div className="flex items-center border border-[#38AFE0] px-1 py-1 bg-[#E7FBFE] rounded gap-1 w-fit">
                              <img src={deployed_code_account} alt="Assigned" />
                              <span className="text-[#004C92] text-xs font-semibold ">
                                Assigned
                              </span>
                            </div>
                        <span className="text-[#5F6D60] font-semibold text-sm">Store manager</span>
                        <span className="bg-[#F6F7F6] border border-[#E1E6E1] text-[#5F6D60] text-xs font-semibold px-2 py-1 rounded">
                          {timeline?.store_manager || "N/A"}
                        </span>
                      </div>
                    </div>
                  ) : 
                  timeline?.order_status === "DISPATCHED" &&
                  timeline.event_type === "order_dispatched" ? (
                    <div className="w-full px-4 py-2 border-t border-t-[#E1E6E1]">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="font-semibold text-[#2E332F] text-sm">{timeline?.user || "N/A"}</span>
                        <span className="bg-[#F6F7F6] border border-[#E1E6E1] text-[#5F6D60] text-xs font-semibold px-1 py-1 rounded">
                          {timeline?.department || "Store Manager"}
                        </span>
                        <span className="ml-auto text-[#79887B] font-medium text-xs">
                          {moment(timeline?.timestamp || timeline?.created).format("MMM DD, YYYY hh:mm A")}
                        </span>
                      </div>
                      <div className="flex items-center gap-2 mt-2">
                        <span className="text-[#5F6D60] font-semibold text-xs">Changed delivery status from</span>
                        <span className="flex items-center gap-1 border border-[#FFC508] bg-[#FFFCC5] text-[#E29700] text-xs font-semibold px-2 py-1 rounded">
                          <img src={deployed_code_history} alt="history" />
                          Processing
                        </span> 
                        <span className="text-[#5F6D60] font-semibold text-xs">to</span>
                        <span className="flex items-center gap-1 border border-[#38AFE0] bg-[#E7FBFE] text-[#0066AF] text-xs font-semibold px-2 py-1 rounded">
                         <LocalShipping style={{ color: "#0066CC", fontSize: "16px" }} />
                          Dispatched
                        </span>
                      </div>
                    </div>
                  )
                  : timeline?.order_status === "DELIVERED" &&
                  timeline.event_type === "order_delivered" ? (
                    <div className="w-full px-4 py-2 border-t border-t-[#E1E6E1]">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="font-semibold text-[#2E332F] text-sm">{timeline?.user || "N/A"}</span>
                        <span className="bg-[#F6F7F6] border border-[#E1E6E1] text-[#5F6D60] text-xs font-semibold px-1 py-1 rounded">
                          {timeline?.department || "Store Manager"}
                        </span>
                        <span className="ml-auto text-[#79887B] font-medium text-xs">
                          {moment(timeline?.timestamp || timeline?.created).format("MMM DD, YYYY hh:mm A")}
                        </span>
                      </div>
                      <div className="flex items-center gap-2 mt-2">
                        <span className="text-[#5F6D60] font-semibold text-xs">Changed delivery status from</span>
                        <span className="flex items-center gap-1 border border-[#38AFE0] bg-[#E7FBFE] text-[#0066AF] text-xs font-semibold px-2 py-1 rounded">
                         <LocalShipping style={{ color: "#0066CC", fontSize: "16px" }} />
                          Dispatched
                        </span> 
                        <span className="text-[#5F6D60] font-semibold text-xs">to</span>
                        <span className="flex items-center gap-1 border bg-[#E1F7E3] text-[#24752B] border-[#72B278] text-xs font-semibold px-2 py-1 rounded">
                             <img src={inventory_icon} alt="inventory_icon" />
                          Delivered
                        </span>
                      </div>
                    </div>
                  )
                  : null }
                  </div>
                );
              })}
            </>
          )}
        </>
      )}
      {/* <DeliveryDetails
        name={"Azeez Olayemi"}
        time={"Now"}
        department={"Customer Success Team"}
      /> */}
      {/* <Alternative
        name={"Celina Avong"}
        time={"Mar 27, 2023 02:36 PM"}
        department={" Sales Department"}
      /> */}
      {/* <NotInStock
        name={"Celina Avong"}
        time={"Mar 27, 2023 02:36 PM"}
        department={" Sales Department"}
      />
      <StockConfirmation
        name={"Celina Avong"}
        time={"Mar 27, 2023 02:36 PM"}
        department={" Sales Department"}
      />
      <OrderPlaced
        name={"Abubakar Jesam"}
        time={"Mar 27, 2023 02:36 PM"}
        paymentStatus={true}
      /> */}
    </div>
  );
};

export default OrderTimeline;
